<template>
  <div id="login">
    <div class="loginBox" @click="changeImage(3)">
      <div class="auth-form">
        <div class="panfish">
          <img :src="imageURL" alt="" />
        </div>
        <!-- 关闭按钮 -->
        <van-tabs v-model="active" animated>
          <van-tab title="绑定微信">
            <!-- 账号密码登录 -->
            <van-cell-group v-show="!isShowSMSLogin">
              <van-field v-model="editItem.Mobile" required clearable label="手机号" maxlength="11"
                @click.stop="changeImage(0)" :error-message="phoneNumberRight ? '' : '手机号格式不正确'" placeholder="手机号" />
              <van-field v-model="editItem.Password" type="password" label="密码" placeholder="密码" required
                @click.stop="changeImage(1)" autocomplete />
              <!-- 手机号快捷登录 -->
            </van-cell-group>
            <van-cell-group v-show="isShowSMSLogin">
              <van-field v-model="editItem.Mobile" required clearable maxlength="11" label="手机号" placeholder="手机号"
                :error-message="phoneNumberRight ? '' : '手机号格式不正确'" />
              <van-field v-model="imgUrlData" center clearable maxlength="4" placeholder="请输入验证码">
                <img class="verificationImage" :src="CaptchaUrl" alt="captcha" @click="onReloadCaptcha" ref="imgCaptcha"
                  slot="button" />
              </van-field>
              <van-field center clearable required label="验证码" placeholder="验证码" maxlength="6"
                v-model="editItem.SmsCaptcha">
                <van-button slot="button" size="small" type="primary" v-if="!countDown" :disabled="captchaDisable"
                  ref="getAuthBtn" @click="onSendLoginSms">发送验证码
                </van-button>
                <van-button slot="button" size="small" type="primary" disabled="" v-else>已发送{{ countDown }}s
                </van-button>
              </van-field>
            </van-cell-group>
            <van-button type="info" size="large" style="margin-top:0.18rem" @click="login">绑定
            </van-button>
            <div class="lnks">
              <div class="switchLogin" @click="switchLogin">
                {{ this.isShowSMSLogin ? "账号密码绑定" : "短信验证码绑定" }}
              </div>
              <div class="switchLogin" @click="toSignUp()">新账注册</div>
            </div>
          </van-tab>
        </van-tabs>
      </div>
    </div>
  </div>
</template>

<script type="text/javascript">
import { Toast } from "vant";
import { bindWeChat, getWeChat, SendLoginSms } from "~/api/user";
import { loadUser } from "~/services/UserService";
import { getData, saveData } from "~/services/RememberService";
import * as captchaService from "~/services/captchaService";
import { isEmptyStr, regMobile } from "~/script/utils";

const loginImage = require("~/images/login/normal.png");

export default {
  name: "Login",
  data() {
    return {
      countDown: 0,
      active: 0,

      editItem: {
        Mobile: "",
        SmsCaptcha: "",
        Password: "",
        PasswordInputType: "password"
      },

      CaptchaUrl: "",
      imgUrlData: "",

      isShowSMSLogin: false,
      switchLoginMsg: "账号密码登录",
      imageURL: loginImage,
      smsCaptchaResult: null,
      userInfo: null,

      code: '',
      weChatData: {}
    };
  },
  computed: {
    // 1.手机号码验证
    phoneNumberRight() {
      const value = this.editItem.Mobile;
      // 1.1 当输入的手机号大于10位进行验证
      if (value.length > 10) {
        return /[1][3,4,5,6,7,8,9][0-9]{9}$/.test(value);
      }
      return true;
    },
    // 2.发送验证码按钮显示
    captchaDisable() {
      if (this.editItem.Mobile.length > 10 && this.phoneNumberRight) {
        return false;
      }

      return true;
    }
  },
  methods: {
    toSignUp() {
      this.$router.push({ name: "register" })
    },
    // 获取微信信息
    async getWeChatData() {
      const { code } = this.$route.query
      this.code = code
      const params = {
        Id: code
      }
      const data = await getWeChat(params)
      this.weChatData = Object.assign({}, data)
    },

    changeImage(index) {
      if (index == 0) {
        this.imageURL = require("./../../images/login/greeting.png");
      } else if (index == 1) {
        this.imageURL = require("./../../images/login/blindfold.png");
      } else {
        this.imageURL = require("./../../images/login/normal.png");
      }
    },

    async login() {
      const validateError = this.validateLogin();
      if (validateError) {
        Toast.fail(validateError);
        return;
      }

      const { editItem, isShowSMSLogin } = this;
      saveData({
        LoginMobile: editItem.Mobile
      });
      const { sendData } = this.getLoginData();

      if (!isShowSMSLogin) {
        sendData.BindMode = 1
      } else {
        sendData.BindMode = 2

      }

      sendData.Id = this.code
      await bindWeChat(sendData);

      await loadUser();

      this.$router.push("/");
    },

    validateLogin() {
      const { isShowSMSLogin } = this;
      if (!isShowSMSLogin) {
        return this.validateMobileLogin();
      } else {
        return this.validateSmsLogin();
      }

      throw new Error("未找到校验函数。");
    },

    validateMobileLogin() {
      const { Mobile, Password } = this.editItem;
      if (!Mobile) {
        return "请输入手机号码";
      }

      const mobileRe = /^1\d{10}$/;
      if (!mobileRe.test(Mobile.trim())) {
        return "请输入正确的手机号码";
      }

      if (!Password) {
        return "请输入密码";
      }

      return null;
    },

    validateSmsLogin() {
      const { Mobile, SmsCaptcha } = this.editItem;
      if (!Mobile) {
        return "请输入手机号码";
      }

      const mobileRe = /^1\d{10}$/;
      if (!mobileRe.test(Mobile.trim())) {
        return "请输入正确的手机号码";
      }

      if (!SmsCaptcha) {
        return "请输入短信验证码";
      }

      return null;
    },

    switchLogin() {
      this.isShowSMSLogin = !this.isShowSMSLogin;
    },

    getMobileLoginData() {
      const { Mobile, Password } = this.editItem;
      const sendData = { Mobile, Password };
      return { sendData: { Mobile, Password } };
    },

    getSmsLoginData() {
      const { Mobile, SmsCaptcha } = this.editItem;
      return { sendData: { Mobile, SmsCaptcha } };
    },

    //处理登录方式
    getLoginData() {
      const { isShowSMSLogin } = this;
      if (!isShowSMSLogin) {
        return this.getMobileLoginData();
      } else {
        return this.getSmsLoginData();
      }

      throw new Error("未找到登录数据");
    },

    // 图文验证码
    // 图片验证码
    async onReloadCaptcha() {
      this.CaptchaUrl = await captchaService.getImageUrl();
    },

    async onSendLoginSms() {
      let imgUrlData = this.imgUrlData;
      let err = "";
      if (isEmptyStr(this.editItem.Mobile) || !regMobile(this.editItem.Mobile)) {
        err = "请输入正确的手机号码";
      } else if (!imgUrlData) {
        err = "请先输入图文验证码";
      }

      if (err) {
        Toast.fail(err);
        return false;
      }

      this.countDown = 10;
      this.timeIntervalID = setInterval(() => {
        this.countDown--;
        // 4.1 如果减到0 则清除定时器
        if (this.countDown == 0) {
          clearInterval(this.timeIntervalID);
        }
      }, 1000);

      const captchaId = await captchaService.getCaptchaId();
      let params = {
        Mobile: this.editItem.Mobile,
        CaptchaId: captchaId,
        Captcha: this.imgUrlData
      };
      try {
        SendLoginSms(params);
        Toast.success("验证码已发送");
      } catch (e) {
        this.onReloadCaptcha()
        throw e;
      }
    }
  },

  async created() {
    const rememberData = getData();
    if (rememberData) {
      const { LoginMobile } = rememberData;
      this.editItem.Mobile = LoginMobile;
    }
    await this.getWeChatData()
    await this.onReloadCaptcha();
  }
};
</script>
<style lang="less" scoped>
#login {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: url("../../images/login/login_bng.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  background-attachment: fixed;

  .loginBox {
    display: flex;
    align-items: center;
    justify-content: center;
    position: fixed;
    opacity: 0.95;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 500;

    .auth-form {
      position: relative;
      padding: 0.34rem;
      width: 4.8rem;
      max-width: 90%;
      font-size: 0.2rem;
      background-color: #fff;
      border-radius: 8px;
      box-sizing: border-box;
    }

    img {
      position: absolute;
      top: 0.2rem;
      left: 50%;
      width: 0.75rem;
      transform: translate(-50%, -70%);
      z-index: 1;

      @media screen and (max-width: 320px) {
        top: 0.085rem;
        transform: translate(-50%, -40%);
        width: 0.85rem;
      }
    }

    .closeButton {
      position: absolute;
      right: 0.085rem;
      top: 0.085rem;
    }

    .verificationImage {
      position: absolute;
      right: 0;
      width: 0.7rem;
      height: 0.3rem;
      margin-left: 0.8rem;
    }

    .switchLogin {
      margin-top: 0.085rem;
      font-size: 0.14rem;
    }
  }
}

.title {
  padding: 0.085rem;
  font-size: 0.085rem;
  color: grey;
}

.agreement {
  // margin-top: 1.667rem;
  line-height: 0.18rem;
  color: #767676;
  font-size: 0.067rem;

  .agreement-box {
    color: blue;
  }

}

.lnks {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
</style>
